export const getPortalFoodMeasures = (API, request, callback) => {
    API.get(`foodmeasures`).then(response => {
        callback(response);
    }).catch(error => {
        console.log(error);
    });
}
